// let url = window.location.href
// let urlObj = new URL(url)
// let host = urlObj.hostname
// let scheme = urlObj.protocol
const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'index',
    'user',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 lighty
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: 'AI测虫',
  internalApi: false,
  apiUrl: 'https://cloud.cechong.mokekeji.com',
  appID: 'no appid',
  masterKey: 'no masterKey',
  restKey: '',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
